<template>
  <transition name="fade">
    <div class="dialog-wrapper" v-show="show">
      <div class="dialog-content absolute bg-FFFFFF fb fb-main-center fb-col">
        <div
          class="dialog-hd font-36"
          :class="{ 'text-left pl-24': titleLeft }"
          v-show="title"
          >{{ title }}</div
        >
        <div class="dialog-bd c-171A1D-56 font-30">
          <slot name="content">
            {{ content }}
          </slot>
        </div>
        <div
          class="dialog-ft relative c-006AFE font-34 ff-medium text-bold-500 text-center fb"
          :class="{ 'text-right pr-24': buttonRight }"
        >
          <template v-if="buttons.length > 1">
            <slot name="buttons">
              <div
                class="dialog-btn dialog-btn_default item-flex-1 bt"
                :class="{ bt: !buttonRight }"
                @click.stop="defaultClick"
                >{{ buttons[0] }}</div
              >
              <div
                class="dialog-btn dialog-btn_primary item-flex-1 bt bl"
                @click.stop="primaryClick"
                >{{ buttons[1] }}</div
              >
            </slot>
          </template>
          <template v-else>
            <slot name="buttons">
              <div
                class="dialog-btn dialog-btn_default item-flex-1"
                :class="{ bt: !buttonRight }"
                @click.stop="defaultClick"
                >{{ buttons[0] }}</div
              >
            </slot>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  props: {
    titleLeft: {
      type: Boolean,
      default: false
    },
    buttonRight: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    buttons: {
      type: Array,
      default() {
        return ['取消', '确认']
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerToChoose(item, index) {
      this.$emit('choose', item, index)
    },
    primaryClick() {
      this.$emit('click', { buttonIndex: 0 })
    },
    defaultClick() {
      this.$emit('click', { buttonIndex: 1 })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgba(25, 31, 37, 0.28);
  z-index: 1;
  .dialog-content {
    top: 50%;
    max-height: 90%;
    text-align: center;
    border-radius: 12px;
    overflow: hidden;
    left: 26px;
    right: 26px;
    transform: translateY(-50%);
    @media screen and (min-width: 352px) {
      width: 300px;
      margin: 0 auto;
    }
    .dialog-hd {
      padding: 20px 12px 10px 12px;
    }
    .pl-24 {
      padding-left: 24px;
    }
    .dialog-bd {
      padding: 0 24px 14px 24px;
      line-height: 1.4;
    }
    .dialog-ft {
      .dialog-btn {
        text-decoration: none;
        padding: 12px 4px;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
  .sheet-container {
    transition: all 0.3s ease;
  }
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  .sheet-container {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
</style>
